import { render, staticRenderFns } from "./IcpFooter.vue?vue&type=template&id=a85252fc&scoped=true"
var script = {}
import style0 from "./IcpFooter.vue?vue&type=style&index=0&id=a85252fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85252fc",
  null
  
)

export default component.exports